import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api'
import { useStocksModel, StocksModal } from '@entities/stocks'
import { IStocksResult } from './../model/types'

// Store

export default /*#__PURE__*/_defineComponent({
  __name: 'Stocks',
  emits: ['positionModal'],
  setup(__props, { emit }) {

const stocksModel = useStocksModel()

// Emits


// Data
const titleModal = ref<string>('')
const descriptionModal = ref<string>('')
const modalActive = ref<boolean>(false)

const onModal = (val: IStocksResult) => {
  titleModal.value = val.title
  descriptionModal.value = val.description
  positionModal(true)
  modalActive.value = true
}

const closeModal = () => {
  modalActive.value = false
  positionModal(false)
}

const positionModal = (val: boolean) => emit('positionModal', val)

return { __sfc: true,stocksModel, emit, titleModal, descriptionModal, modalActive, onModal, closeModal, positionModal, StocksModal }
}

})